var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "0 0 100 100",
    y: 0,
    x: 0,
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    style: {
      margin: "initial",
      display: "block",
      shapeRendering: "auto"
    },
    preserveAspectRatio: "xMidYMid",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes animate {\n    0% {\n        transform: translate(0px, 0px) rotate(0deg) scale(0.91, 0.91) skew(0deg, 0deg);\n        opacity: 1;\n    }\n    4% {\n        transform: translate(0px, 0px) rotate(0deg) scale(0.91, 0.91);\n    }\n    8% {\n        animation-timing-function: cubic-bezier(0.69, 0.6, 0.35, 0.27);\n        transform: translate(0px, 0px) rotate(0deg) scale(0.91, 0.91);\n    }\n    14% {\n        transform: translate(0px, 0px) rotate(0deg) scale(0.93, 0.93);\n    }\n    18% {\n        transform: translate(0px, 0px) rotate(0deg) scale(0.94, 0.94);\n    }\n    22% {\n        animation-timing-function: cubic-bezier(0.67, 0.66, 0.34, 0.33);\n        transform: translate(0px, 0px) rotate(0deg) scale(0.96, 0.96);\n    }\n    26% {\n        transform: translate(0px, 0px) rotate(0deg) scale(0.97, 0.97);\n    }\n    30% {\n        transform: translate(0px, 0px) rotate(0deg) scale(0.99, 0.99);\n    }\n    34% {\n        animation-timing-function: cubic-bezier(0.65, 0.71, 0.32, 0.38);\n        transform: translate(0px, 0px) rotate(0deg) scale(1.01, 1.01);\n    }\n    40% {\n        animation-timing-function: cubic-bezier(0.64, 0.74, 0.31, 0.41);\n        transform: translate(0px, 0px) rotate(0deg) scale(1.02, 1.02);\n    }\n    46% {\n        animation-timing-function: cubic-bezier(0.6, 0.91, 0.23, 0.63);\n        transform: translate(0px, 0px) rotate(0deg) scale(1.03, 1.03);\n    }\n    50% {\n        transform: translate(0px, 0px) rotate(0deg) scale(1.03, 1.03);\n    }\n    54% {\n        transform: translate(0px, 0px) rotate(0deg) scale(1.03, 1.03);\n    }\n    58% {\n        animation-timing-function: cubic-bezier(0.69, 0.6, 0.35, 0.27);\n        transform: translate(0px, 0px) rotate(0deg) scale(1.03, 1.03);\n    }\n    64% {\n        transform: translate(0px, 0px) rotate(0deg) scale(1.01, 1.01);\n    }\n    68% {\n        transform: translate(0px, 0px) rotate(0deg) scale(1, 1);\n    }\n    72% {\n        animation-timing-function: cubic-bezier(0.67, 0.66, 0.34, 0.33);\n        transform: translate(0px, 0px) rotate(0deg) scale(0.98, 0.98);\n    }\n    76% {\n        animation-timing-function: cubic-bezier(0.66, 0.68, 0.33, 0.35);\n        transform: translate(0px, 0px) rotate(0deg) scale(0.97, 0.97);\n    }\n    82% {\n        animation-timing-function: cubic-bezier(0.65, 0.71, 0.32, 0.38);\n        transform: translate(0px, 0px) rotate(0deg) scale(0.94, 0.94);\n    }\n\n    88% {\n        animation-timing-function: cubic-bezier(0.65, 0.73, 0.31, 0.4);\n        transform: translate(0px, 0px) rotate(0deg) scale(0.92, 0.92);\n    }\n    94% {\n        animation-timing-function: cubic-bezier(0.63, 0.8, 0.28, 0.48);\n        transform: translate(0px, 0px) rotate(0deg) scale(0.91, 0.91);\n    }\n    100% {\n        animation-timing-function: cubic-bezier(0.63, 0.8, 0.28, 0.48);\n        transform: translate(0px, 0px) rotate(0deg) scale(0.91, 0.91);\n    }\n}")), /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(0.8, 0.8)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      opacity: 1,
      transformOrigin: "50px 50px",
      transform: "matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1)",
      animation: "1s linear -0.55s infinite normal forwards running animate",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    stroke: "#333",
    fill: "#f4e6c8",
    d: "M83.9 26.8c0-2-1.3-3.7-3-4.4-.7-2.2-2.5-4-4.8-4.5-.5-3.1-3.2-5.4-6.4-5.4-2.9 0-5.4 1.9-6.3 4.6-.8-.3-1.6-.5-2.5-.5-.6 0-1.2.1-1.8.3-1.1-2-3.3-3.4-5.8-3.4-.8 0-1.5.1-2.2.4-1-2.2-3.3-3.8-5.9-3.8-3.5 0-6.3 2.7-6.5 6.1-.9-.4-1.9-.7-2.9-.7-.6 0-1.1.1-1.6.2-1.2-1.4-3-2.3-4.9-2.3-3.6 0-6.6 2.9-6.6 6.6 0 .3 0 .7.1 1-1.4 0-2.7.5-3.8 1.3-1.6 1.2-2.7 3.1-2.7 5.3 0 2.2 1 4.1 2.7 5.3.7.5 1.6.9 2.5 1.1h59.1c.4-.8.7-1.8.8-2.8 1.3-.8 2.5-2.5 2.5-4.4z",
    style: {
      strokeWidth: 3.5,
      fill: "rgb(244, 230, 200)",
      stroke: "rgb(51, 51, 51)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      opacity: 1,
      transformOrigin: "50px 50px",
      transform: "matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1)",
      animation: "1s linear -0.6s infinite normal forwards running animate",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    stroke: "#333",
    fill: "none",
    d: "M42.6 29.4c-1.9-1.9-1.8-5.5.2-7.3s5.6-1.5 7.3.6c1.2 1.5 1.1 4.1-.3 5.5",
    style: {
      strokeWidth: 3.5,
      stroke: "rgb(51, 51, 51)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      opacity: 1,
      transformOrigin: "50px 50px",
      transform: "matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1)",
      animation: "1s linear -0.65s infinite normal forwards running animate",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    stroke: "#333",
    fill: "none",
    d: "M51 25c.9-1.5 2.8-2.2 4.5-1.7 1.6.5 2.9 2.2 2.8 3.9",
    style: {
      strokeWidth: 3.5,
      stroke: "rgb(51, 51, 51)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      opacity: 1,
      transformOrigin: "50px 50px",
      transform: "matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1)",
      animation: "1s linear -0.7s infinite normal forwards running animate",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    stroke: "#333",
    fill: "#f4e6c8",
    d: "M76 17.9c-.9 0-7.3-.5-7.2 6",
    style: {
      strokeWidth: 3.5,
      fill: "rgb(244, 230, 200)",
      stroke: "rgb(51, 51, 51)"
    }
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      opacity: 1,
      transformOrigin: "50px 50px",
      transform: "matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1)",
      animation: "1s linear -0.75s infinite normal forwards running animate",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    stroke: "#333",
    fill: "#e15c64",
    d: "M36.6 90h-7c-1.5 0-2.7-1.1-2.9-2.6l-5.5-53.6h11.9L36.6 90z",
    style: {
      strokeWidth: 3.5,
      fill: "rgb(147, 2, 21)",
      stroke: "rgb(51, 51, 51)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      opacity: 1,
      transformOrigin: "50px 50px",
      transform: "matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1)",
      animation: "1s linear -0.8s infinite normal forwards running animate",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2 90h-9.6l-3.4-56.2H45z",
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    stroke: "#333",
    fill: "#fff",
    style: {
      strokeWidth: 3.5,
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(51, 51, 51)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      opacity: 1,
      transformOrigin: "50px 50px",
      transform: "matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1)",
      animation: "1s linear -0.85s infinite normal forwards running animate",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8 90h-9.6L45 33.8h11.9z",
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    stroke: "#333",
    fill: "#e15c64",
    style: {
      strokeWidth: 3.5,
      fill: "rgb(147, 2, 21)",
      stroke: "rgb(51, 51, 51)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      opacity: 1,
      transformOrigin: "50px 50px",
      transform: "matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1)",
      animation: "1s linear -0.9s infinite normal forwards running animate",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.3 90h-9.5l1.1-56.2h11.9z",
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    stroke: "#333",
    fill: "#fff",
    style: {
      strokeWidth: 3.5,
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(51, 51, 51)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      opacity: 1,
      transformOrigin: "50px 50px",
      transform: "matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1)",
      animation: "1s linear -0.95s infinite normal forwards running animate",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    stroke: "#333",
    fill: "#e15c64",
    d: "M72.3 90h-7l3.4-56.2h11.9l-5.5 53.6c-.1 1.5-1.3 2.6-2.8 2.6z",
    style: {
      strokeWidth: 3.5,
      fill: "rgb(147, 2, 21)",
      stroke: "rgb(51, 51, 51)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-layer"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani",
    style: {
      opacity: 1,
      transformOrigin: "50px 50px",
      transform: "matrix3d(0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 0.91, 0, 0, 0, 0, 1)",
      animation: "1s linear -1s infinite normal forwards running animate",
      transformBox: "view-box"
    }
  }, /*#__PURE__*/React.createElement("path", {
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    stroke: "#333",
    fill: "#f7b26a",
    d: "M56.9 66.7h-12c-2.8 0-5-2.2-5-5v-4.5c0-2.8 2.2-5 5-5h12c2.8 0 5 2.2 5 5v4.5c0 2.8-2.2 5-5 5z",
    style: {
      strokeWidth: 3.5,
      fill: "rgb(247, 178, 106)",
      stroke: "rgb(51, 51, 51)"
    }
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.b6939577c401a13b185fc55f2cdc77e4.svg";
export { ForwardRef as ReactComponent };